import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionService } from '../collection.service';
import { Billet } from '../models/billet';
import * as printJS from 'print-js';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-collection-resume-billet',
	templateUrl: './resume-billet.component.html',
	styleUrls: ['./resume-billet.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionResumeBilletComponent implements OnInit {

	public message = 'Boleto gerado com sucesso!';
	public messageType = 'success';
	public billet: Billet;

	constructor(
		private route: ActivatedRoute,
		private collectionService: CollectionService,
		private router: Router,
	) {}

	ngOnInit(): void {
		this.billet = this.collectionService.getBilletEmited();
	}

	printPdf() {
		this.collectionService.getBilletPdf(this.billet.numeroTitulo).subscribe(data => {
			if (data.Sucesso) {
				printJS({ printable: data.Retorno, type: 'pdf', base64: true });
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	emitDownloadPdf() {
		this.downloadExtractPdfFile();
	}

	emitPrint() {
		this.printPdf();
	}

	downloadExtractPdfFile() {
		this.collectionService.getBilletPdf(this.billet.numeroTitulo).subscribe(data => {
			const linkSource = `data:application/pdf;base64,${data.Retorno}`;
			const downloadLink = document.createElement('a');
			const fileName = 'boleto';
			const byteCharacters = atob(data.Retorno);
			const byteNumbers = new Array(byteCharacters.length);

			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			const blob = new Blob([byteArray], {type: 'application/pdf'});
			const blobObject = new Blob([data.Retorno], { type: 'application/pdf' });

			if (this.isIE()) {
				window.navigator.msSaveOrOpenBlob(blob);
			} else if (this.isFirefox()) {
				downloadLink.href = linkSource;
				downloadLink.download = 'boleto.pdf';
				document.body.appendChild(downloadLink);
				downloadLink.setAttribute('target', '_blank');
				downloadLink.click();
			} else if (this.isEdge()) {
				window.navigator.msSaveOrOpenBlob(blob, 'boleto.pdf');
			} else {
				downloadLink.href = linkSource;
				downloadLink.download = fileName;
				downloadLink.click();
			}
		},
		error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem });
		});

	}

	isIE() {
		const ua = navigator.userAgent;
		/* MSIE used to detect old browsers and Trident used to newer ones*/
		const is_ie = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1;

		return is_ie;
	}

	isFirefox() {
		const ua = navigator.userAgent;
		const is_firefox = ua.toLowerCase().indexOf('firefox') > -1;

		return is_firefox;

	}

	isEdge() {
		const ua = navigator.userAgent;
		const is_edge = ua.toLowerCase().includes('edge');

		return is_edge;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/collection/resume-billet/resume-billet.component.ts